/** Deterministic index in `[0, n)` from a string — same input always produces the same index. */
export function hashIndex(str: string, n: number): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0
  }
  return Math.abs(hash) % n
}
